import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, FileStack } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import api from '@/api/api';
import { toast } from 'sonner';
import DocumentManager from './DocumentManager';

export default function DocumentPage({ entityType }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dossier, setDossier] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDossier = useCallback(async () => {
    try {
      const res = await api.get('/documents/dossier', {
        params: { entity_id: id, entity_type: entityType }
      });
      if (res.data?.success) setDossier(res.data.data);
    } catch (err) {
      toast.error('Erro ao carregar dossiê');
    } finally {
      setLoading(false);
    }
  }, [id, entityType]);

  useEffect(() => {
    if (id) fetchDossier();
  }, [fetchDossier]);

  return (
    <div className="space-y-6 pb-20">
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          size="icon"
          onClick={() => navigate(entityType === 'driver' ? '/drivers' : '/vehicles')}
        >
          <ArrowLeft size={20} />
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {loading ? <span className="inline-block h-8 w-48 bg-muted rounded animate-pulse" /> : dossier?.entityName}
          </h1>
          <p className="text-xs font-semibold uppercase text-primary mt-1">Gestão de Documentos</p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <FileStack className="text-muted-foreground" />
            Dossiê de Conformidade
          </CardTitle>
        </CardHeader>
        <CardContent>
          <DocumentManager
            entityId={id}
            entityType={entityType}
            requirements={dossier?.requirements || []}
            uploads={dossier?.uploads || []}
            loading={loading}
            onRefresh={fetchDossier}
          />
        </CardContent>
      </Card>
    </div>
  );
}
